import React, { Fragment, useContext } from 'react'
import SignupContext from 'modules/react/signup/SignupContext'

export default function Step1RightContentDynamic () {

  const signupContext = useContext(SignupContext)
  const { modalRightContentStrings } = signupContext

  return (
    <>
      {
        modalRightContentStrings?.title && (
          <div className="title title--h4">{modalRightContentStrings.title}</div>
        )
      }

      {
        modalRightContentStrings?.content && modalRightContentStrings.content.map((item, index) => {
          if (item.acf_fc_layout === 'one_column') {
            return (
              <Fragment key={index}>
                {item.subtitle && <div className="title title--h6">{item.subtitle}</div>}
                {item.content && <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: item.content }}/>}
              </Fragment>
            )
          }

          if (item.acf_fc_layout === 'two_columns') {
            return (
              <div key={index} className="content-columns">

                <div className="content-columns__column">
                  {item.subtitle_column_one && <div className="title title--h7">{item.subtitle_column_one}</div>}
                  {item.content_column_one && <div className="wysiwyg wysiwyg--fs14" dangerouslySetInnerHTML={{ __html: item.content_column_one }}/>}
                </div>

                <span className="content-columns__separator"></span>

                <div className="content-columns__column">
                  {item.subtitle_column_two && <div className="title title--h7">{item.subtitle_column_two}</div>}
                  {item.content_column_two && <div className="wysiwyg wysiwyg--fs14" dangerouslySetInnerHTML={{ __html: item.content_column_two }}/>}
                </div>

              </div>
            )
          }

          return null
        })
      }
    </>
  )
}